import React, { Component } from 'react';
import { Table } from 'react-bootstrap';
import { toast } from 'react-hot-toast';
import ModalCarga from '../ModalCarga';

class Inventario extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            data: [],
            mostrar: 'conExistencia'
        }
    }

    componentDidMount = async () => {
        this.select();
    }

    componentDidUpdate = (prevProps) => {
        if ((prevProps.idSucursal !== this.props.idSucursal) || (prevProps.fecha !== this.props.fecha)) {
            this.select()
        }
    }

    numberWithCommas = (x) => {
        x = Number(x).toFixed(2);
        if (x === 0) {
            return '0.00';
        }else{
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
    }

    select = async () => {  
        this.setState({ loading: true });
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ operacion: 'selectInventario', idSucursal: this.props.idSucursal })
        };
        const response = await fetch('https://admin.panaderialazcano.com/php/DB/reportes.php', requestOptions);
        const data = await response.json();
        console.log(data);
        if (data.error === 0) {
            this.setState({
                data: data,
                loading: false
            })
        }else{
            this.setState({
                loading: false
            })
            toast.error('Error al obtener datos');
            console.log(data.mensaje);
        }
    }

    onChangeValue = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    render() { 
        return ( 
            <>
                <ModalCarga show={this.state.loading}/>
                <div className="col-2">
                    <label className='ms-1' htmlFor="tipo">Mostrar</label>
                    <select name="mostrar" id="mostrar" className='form-control' value={this.state.mostrar} onChange={this.onChangeValue}>
                        <option value="todo">Todo</option>
                        <option value="conExistencia">Con Existencia</option>
                        <option value="sinExistencia">Sin Existencia</option>
                    </select>
                </div>
                <div className="col-12 mt-5"/>
                {/*      TABLA TODOS LOS PRODUCTOS      */
                    this.state.mostrar === 'todo' &&
                        ((this.state.data.inventario && this.state.data.inventario.todo.productos.length > 0) ?
                            <div className="col-6 mx-auto">
                                <Table bordered striped>
                                    <thead className='bg-black text-white' style={{ position: 'sticky', top: 0, zIndex: 1 }}>
                                        <tr>
                                            <th>Producto</th>
                                            <th style={{ whiteSpace: 'nowrap' }}>Precio Unitario</th>
                                            <th>Cantidad</th>
                                            <th>Importe</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            this.state.data.inventario.todo.productos.map((e) =>                                            
                                            <tr key={e.idProducto}>
                                                <td className=''>{e.nombre}</td>
                                                <td className='text-end'>${this.numberWithCommas(e.precioUnitario)}</td>
                                                <td className='text-end'>{e.piezas}</td>
                                                <td className='text-end'>${this.numberWithCommas(e.importeInventario)}</td>
                                            </tr>                                            
                                            )
                                        }
                                        <tr>
                                            <td colSpan={2} className="bg-gray text-white text-center">TOTAL</td>
                                            <td className='bg-gray text-white text-end'>{this.state.data.inventario.todo.totalPiezas}</td>
                                            <td className='bg-gray text-white text-end'>${this.numberWithCommas(this.state.data.inventario.todo.totalImporte)}</td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </div>
                        :
                            <h1>No hay productos</h1>
                        )

                }
                {/*      TABLA PRODUCTOS CON EXISTENCIA      */
                    this.state.mostrar === 'conExistencia' &&
                        ((this.state.data.inventario && this.state.data.inventario.conExistencia.productos.length > 0) ?
                            <div className="col-6 mx-auto">
                                <Table bordered striped>
                                    <thead className='bg-black text-white' style={{ position: 'sticky', top: 0, zIndex: 1 }}>
                                        <tr>
                                            <th>Producto</th>
                                            <th style={{ whiteSpace: 'nowrap' }}>Precio Unitario</th>
                                            <th>Cantidad</th>
                                            <th>Importe</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            this.state.data.inventario.conExistencia.productos.map((e) =>                                            
                                            <tr key={e.idProducto}>
                                                <td className=''>{e.nombre}</td>
                                                <td className='text-end'>${this.numberWithCommas(e.precioUnitario)}</td>
                                                <td className='text-end'>{e.piezas}</td>
                                                <td className='text-end'>${this.numberWithCommas(e.importeInventario)}</td>
                                            </tr>                                            
                                            )
                                        }
                                        <tr>
                                            <td colSpan={2} className="bg-gray text-white text-center">TOTAL</td>
                                            <td className='bg-gray text-white text-end'>{this.state.data.inventario.conExistencia.totalPiezas}</td>
                                            <td className='bg-gray text-white text-end'>${this.numberWithCommas(this.state.data.inventario.conExistencia.totalImporte)}</td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </div>
                        :
                            <h1>No hay productos con existencias</h1>
                        )

                }
                {/*      TABLA PRODUCTOS SIN EXISTENCIA      */
                    this.state.mostrar === 'sinExistencia' &&
                        ((this.state.data.inventario && this.state.data.inventario.sinExistencia.productos.length > 0) ?
                            <div className="col-6 mx-auto">
                                <Table bordered striped>
                                    <thead className='bg-black text-white' style={{ position: 'sticky', top: 0, zIndex: 1 }}>
                                        <tr>
                                            <th>Producto</th>
                                            <th style={{ whiteSpace: 'nowrap' }}>Precio Unitario</th>
                                            <th>Cantidad</th>
                                            <th>Importe</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            this.state.data.inventario.sinExistencia.productos.map((e) =>                                            
                                            <tr key={e.idProducto}>
                                                <td className=''>{e.nombre}</td>
                                                <td className='text-end'>${this.numberWithCommas(e.precioUnitario)}</td>
                                                <td className='text-end'>{e.piezas}</td>
                                                <td className='text-end'>${this.numberWithCommas(e.importeInventario)}</td>
                                            </tr>                                            
                                            )
                                        }
                                        <tr>
                                            <td colSpan={2} className="bg-gray text-white text-center">TOTAL</td>
                                            <td className='bg-gray text-white text-end'>{this.state.data.inventario.sinExistencia.totalPiezas}</td>
                                            <td className='bg-gray text-white text-end'>${this.numberWithCommas(this.state.data.inventario.sinExistencia.totalImporte)}</td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </div>
                        :
                            <h1>No hay productos sin existencias</h1>
                        )

                }
            </>
         );
    }
}
 
export default Inventario;